import auth from "../../utils/auth"
import Axios from "axios"
import { errorHandler } from "../../utils"
import api from '../../api'
import { TIMEOUT } from "../../constants"

const { getTokenFromLocalStorage } = auth()

const service = {
  async getData() {
    return new Promise(function(resolve, reject){
      const token = getTokenFromLocalStorage()

      Axios.get(`${api.base}${api.join_requests}`, {
        timeout: TIMEOUT,
        headers: {
          'X-Api-Key': api.key,
          'Authorization': `JWT ${token}`
        }
      }).then(res => {
        if(res.data){
          if(res.data.results) resolve(res.data.results)
          else resolve(res.data)
        }
        else{
          resolve(res)
        }
      }).catch(err => {
        const message = errorHandler(err)
        reject(message)
      });
    })
  },

  /**
   * PUT - respond to invitation
   */
  async respond(id, status){
    return new Promise(function(resolve, reject){
      let requestBody = {
        statusRequest: status
      }
      console.log('requestBody', requestBody)

      const token = getTokenFromLocalStorage()
      const config = {
        headers: {
          'X-Api-Key': api.key,
          'Authorization': `JWT ${token}`
        }
      }

      if(id){
        /* Axios */
        Axios.put(`${api.base}${api.join_requests_respond}${id}/`, requestBody, config)
        .then(res => {
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },
}

export default service
